import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Table, Loader, Button} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import {columnsTechniciansGroup} from '../../constants';
import TechniciansTable from '../common/TechniciansTable';
import './styles.scss';

class TechniciansGroups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'addTechnicianGroup': false,
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.TechniciansGroups,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchTechniciansGroups();
    this.props.fetchLogisticAreasList();
  }

  componentWillUnmount() {
    this.props.clearTechnicianGroup();
  }

  addNewTechnicianGroup = () => {
    this.setState({'addTechnicianGroup': true});
  };

  cancelAddTechnicianGroup = () => {
    this.setState({'addTechnicianGroup': false});
  };

  renderLoaderOrTechnicianGroups = () => {
    const {loading, list, areasList} = this.props;
    const {addTechnicianGroup} = this.state;

    if (loading) {
      return (
        <Table striped className="toyota-grid">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="100%">
                <Loader active inline="centered" content="Ejecutando" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return (
      <TechniciansTable
        type='groupTechnician'
        cancelAddInfo={this.cancelAddTechnicianGroup}
        addInfo={addTechnicianGroup}
        list={list}
        optionsList={areasList}
        columnsInfo={columnsTechniciansGroup}
      />
    );
  };

  render() {
    return (
      <div className="logistic-group-technicians-container">
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Mantenimiento de Grupo Técnicos</h2>
              <div className="title-bar-actions">
                <Button
                  primary
                  className="toyota-primary"
                  onClick={this.addNewTechnicianGroup}
                >
                  Añadir grupo nuevo técnico
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid className="logistic-area-table">
          {this.renderLoaderOrTechnicianGroups()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'list': state.technicianGroups.list,
    'loading': state.technicianGroups.loading,
    'areasList': state.logisticServices.list,
  };
};

const {
  fetchTechniciansGroups,
  fetchLogisticAreasList,
  clearTechnicianGroup,
  navigateTo,
} = Actions;

const mapDispatchToProps = {
  fetchTechniciansGroups,
  clearTechnicianGroup,
  fetchLogisticAreasList,
  navigateTo,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TechniciansGroups);
